import { useLocation } from 'react-router';

export const useQueryParam = (param) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location?.search ?? '');

    return searchParams.get(param);
};